import * as yup from "yup";

export const validationSchema = yup.object().shape({
  lectureCode: yup.number().typeError("Lecture code must be number").required("Lecture Code is required."),
});

export const initValues = { lectureCode: "" };
